import store from '..'
import axios from 'axios'
import API from '@/common/api'
import LOCALE from '@/common/locale_amenity'
import AMENITY from '@/common/amenity'
import LANG from '@/common/lang'
import UTIL from '@/common/util'

const defaultAmenitySetting = {
  cart: true,
  max: 1,
  orderLimitActive: false, // 요청 제한 (하루또는 투숙기간중 orderMax회만 요청 가능한지?)
  orderLimit: '', // day(하루) || ota(투숙기간)
  orderLimitMessage: UTIL.fillLangs({}, ''),
  orderMax: 1, // 최대 요청 횟수
  itemLimitActive: false, // 1회 요청시 최대 항목 제한
  itemLimit: '', // 1회 요청시 최대 항목수
  available: { // 어메니티 요청 가능 시간
    state: '01',
    set: [
      { id: 'mon', name: '월', available: true, time: [{ from: '00:00', to: '24:00' }] },
      { id: 'tue', name: '화', available: true, time: [{ from: '00:00', to: '24:00' }] },
      { id: 'wed', name: '수', available: true, time: [{ from: '00:00', to: '24:00' }] },
      { id: 'thu', name: '목', available: true, time: [{ from: '00:00', to: '24:00' }] },
      { id: 'fri', name: '금', available: true, time: [{ from: '00:00', to: '24:00' }] },
      { id: 'sat', name: '토', available: true, time: [{ from: '00:00', to: '24:00' }] },
      { id: 'sun', name: '일', available: true, time: [{ from: '00:00', to: '24:00' }] }
    ]
  }
}

export default {
  namespaced: true,
  state: {
    list: [],
    listView: {},
    service: [],
    setting: defaultAmenitySetting,
    order: null,
    category: AMENITY.category,
    filter: {
      word: '',
      list: []
    }
  },
  mutations: {
    listView (state, data) {
      state.listView = data
    },
    initFilter (state) {
      state.filter.word = ''
      state.filter.list = state.category.map(x => x)
    },
    setFilter: function (state, data) {
      Object.keys(data).forEach(function (x) {
        state.filter[x] = data[x]
      })
    },
    setOrder (state, data) {
      state.order = data
    },
    setService (state, data) {
      state.service = data
    },
    applyAll (state, data) {
      state.list = state.list.map(x => {
        return {
          ...x,
          ...data
        }
      })
    },
    setLimitTime (state, data) {
      state.setting.limitTime = data
    },
    setItemData (state, data) {
      const item = state.list.find(item => item.raCode === data.raCode)
      if (item) {
        item[data.key] = data.value
      }
    }
  },
  actions: {
    setAmenityData ({ state }, data) {
      const defaultLang = 'en'
      const listData = AMENITY.data
      const listIds = Object.keys(listData)
      const list = data.filter(x => listIds.includes(x.raCode)).map(x => x.raCode)
      /**
       * response 데이터와 common 데이터 merge => default amenity list data
       * response 데이터에서는 raCode만 가져오고
       * 해당 raCode 기준으로 default common 데이터(state, max)를 맵핑
       * 이 데이터와 개별 데이터(gvf)를 다시 merge하게 됨
       */
      const amenityList = list.map(function (x) {
        return {
          raCode: x,
          ...listData[x]
        }
      })
      /**
       * 검색을 위한 키워드 추가
       * 각 locale 값을 배열로 리턴
       */
      const keyword = LOCALE[defaultLang].map(x => {
        const key = x.term
        // const value = x.definition
        return {
          raCode: key,
          keyword: Object.keys(LOCALE).map(lang => {
            return LOCALE[lang] &&
              LOCALE[lang].find(locale => locale.term === key) &&
              LOCALE[lang].find(locale => locale.term === key).definition
          })
        }
      })
      /**
       * POEDITOR의 각 언어 값이(= LOCALE)
       * 라벨의 각 언어 값에 맵핑
       * 외의 언어는 defaultLang(en)
       */
      function getDefaultLabel (code, defaultLang) {
        const valueObj = LANG.valueObj()
        const langs = Object.keys(valueObj)
        for (let i = 0; i < langs.length; i++) {
          const lang = langs[i]
          valueObj[lang] = LOCALE[lang] && LOCALE[lang].find(locale => locale.term === code)
            ? LOCALE[lang].find(locale => locale.term === code).definition
            : LOCALE[defaultLang].find(locale => locale.term === code)
              ? LOCALE[defaultLang].find(locale => locale.term === code).definition
              : ''
        }
        return valueObj
      }
      /**
       * 검색을 위한 키워드 추가
       * locale 값에 common 데이터의 keyword와 merge
       * 동의어, 관련어 등 common에서 추가하면 된다
       * 어메니티는 호텔별 부르는 명칭이 다르기 때문에
       * 키워드를 적용해주게 됨
       */
      function addLocaleName (array) {
        const arr = array.map((x, i) => {
          const code = x.raCode.toLowerCase()
          const amenityCode = `amenity_${code}`
          return {
            ...x,
            keyword: [...new Set(
              (x.keyword || []).concat(keyword.find(k => k.raCode === amenityCode) ? keyword.find(k => k.raCode === amenityCode).keyword : [])
            )],
            label: x.label || getDefaultLabel(amenityCode, defaultLang)
          }
        })
        return arr
      }
      return addLocaleName(amenityList)
    },
    mergeList ({ state }, data) {
      /**
       * data.data: viewer에 쓸 gvf파일 데이터
       * data.source: 에디터에 필요한 common 데이터
       */
      const list = data.source.map(x => {
        const itemData = data.data.find(d => d.raCode === x.raCode)
        if (itemData) {
          return {
            ...x,
            ...itemData
          }
        } else {
          return {
            ...x,
            service: false
          }
        }
      })
      state.list = list
      state.setting = { ...state.setting, ...data.setting }
      return true
    },
    // 개별데이터 (gvf)
    async getAmenityData ({ commit, state }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: 'amenity/amenity.json'
        })
        const amenityData = res.data.message
        /**
         * 어메니티 세팅에 필요한 데이터 업데이트
         * 새로운 기능/설정이 추가될 때
         * 해당 설정에 대한 키값이 없으므로
         * gvf 파일 불러온 뒤 기본값을 넣어준다
         * (common/amenity.json 에 직접 넣으면 너무 번거로움)
         */
        amenityData.list = amenityData.list.map(x => {
          const isDisabled = x.orderLimitActive
            ? x.pay
              ? !(x.price && parseFloat(x.price) > 0)
              : x.orderMax <= 0
            : false
          return {
            ...x,
            price: x.price || 0,
            padiConversion: x.pay,
            orderLimitActive: x.orderLimitActive, // 요청 제한 (하루또는 투숙기간중 orderMax회만 요청 가능한지?)
            orderLimit: x.orderLimit, // day(하루) || ota(투숙기간)
            orderMax: x.orderMax, // 최대 요청 횟수
            open: false,
            isDisabled: isDisabled,
            disabled: x.disabled || isDisabled
          }
        })
        state.order = amenityData.order || amenityData.list.map(x => x)
        return amenityData
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    // 전체 어메니티 리스트 (system)
    async getAmenity ({ dispatch, commit, state }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_AMENITY,
          id: store.state.authentication.requestId
        })
        // default amenity data 생성
        dispatch('setAmenityData', res.data.message).then((list) => {
          // amenity gvf data 호출
          dispatch('getAmenityData').then((res1) => {
            // default와 맵핑
            if (res1) {
              dispatch('mergeList', {
                source: list,
                data: res1.list,
                setting: { ...defaultAmenitySetting, ...res1.setting }
              }).then(() => {
                return true
              })
              // default를 gvf로 저장 후 다시 호출+맵핑
            } else {
              const defaultAmenityData = {
                category: state.category,
                list: list
              }
              // dispatch('setAmenity', defaultAmenityData).then(() => {
              //   dispatch('getAmenity')
              // })
              dispatch('mergeList', {
                source: list,
                data: defaultAmenityData.list,
                setting: { ...defaultAmenitySetting }
              }).then(() => {
                return true
              })
            }
          })
        })
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async setAmenity ({ state }, data) {
      try {
        return axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.SET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: 'amenity/amenity.json',
          data: JSON.stringify(data)
        })
      } catch (ex) {
        return false
      }
    }
  },
  getters: {
    getList: state => {
      const category = state.category
      const list = state.list.map(x => x).sort((a, b) => {
        return index(a.category) < index(b.category) ? -1 : index(a.category) > index(b.category) ? 1 : 0
      })
      function index (cate) {
        return category.indexOf(cate)
      }
      return list
    },
    getOrder: state => {
      return state.order
    },
    getServiceList: state => state.list.filter(x => x.service),
    getCategory: state => state.category,
    getFilter: state => state.filter,
    getSetting: state => state.setting
  }
}
